import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCidbhKGUc2iV_vb_j9cKdh_1XHYjuwFWc",
  authDomain: "facebook-clone-46.firebaseapp.com",
  databaseURL: "https://facebook-clone-46.firebaseio.com",
  projectId: "facebook-clone-46",
  storageBucket: "facebook-clone-46.appspot.com",
  messagingSenderId: "814415923269",
  appId: "1:814415923269:web:df8c84b0b6c34f6dd17b2c",
  measurementId: "G-VCXSN1TXZ6",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
